/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Util} from "../../Utilities.js";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import GridSection from "../ListComponents/GridSection.jsx";

class CardsSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            currentValue: "",
            selectedItem: -1,
            isOpen: false,
        }

    }


    componentDidMount() {
        this.setData()
    }

    setData() {
        let optionIndex = this.props.options.findIndex(item => ((item.value === (this.props.value?.[0]?.value ?? "")) || (item.value === (this.props.value?.value ?? ""))))
        let option = this.props.options[optionIndex]
        if (option !== undefined) {
            this.setState({
                searchValue: option.label,
                currentValue: option.value,
                currentColor: option.color,
                selectedItem: optionIndex
            })
        } else {
            this.setState({searchValue: "", currentValue: ""})


        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.options !== this.props.options || prevProps.value?.[0]?.value !== this.props.value?.[0]?.value || prevProps.value?.value !== this.props.value?.value) {
            this.setData()
        }
    }


    displayItem(option) {

        let isSelected = (option.value === this.state.currentValue)

        let iconColor = Util.color.getTextColorForBackground(option?.color ?? "#fffff")

        // if (option.optionType === "input" && isSelected) {
        //
        //
        //     return (<button
        //         style={{backgroundColor: option?.color}}
        //         onClick={() => {
        //             if (this.props.onChange !== undefined) {
        //                 this.props.onChange(option)
        //             }
        //             this.setState({
        //                 searchValue: option.label,
        //                 currentValue: option.value,
        //                 currentColor: option.color,
        //                 isOpen: false
        //             })
        //
        //         }}
        //         className={` rounded-md p-1 text-sm font-normal border cursor-pointer focus:outline-none bg-blue-400 border-blue-400 hover:bg-blue-300 focus-visible:ring-1 col-span-2 transition-width duration-300`}>
        //
        //         <input placeholder={option.label}
        //                className={"w-full text-sm rounded focus:outline-none focus:ring-0 border-none text-gray-500"}>
        //         </input>
        //     </button>)
        //
        //
        // }


        return (<button
            key={option.value}
            style={{backgroundColor: option?.color}}
            onClick={(event) => {
                if (this.props.onChange !== undefined) {
                    this.props.onChange(option)
                }
                event.preventDefault()
                event.stopPropagation()
                this.setState({
                    searchValue: option.label,
                    currentValue: option.value,
                    currentColor: option.color,
                    isOpen: false
                })

            }}
            className={` rounded-md py-2 px-2 text-sm font-normal border cursor-pointer focus:outline-none  ${isSelected ? (' border-blue-500 text-blue-800 bg-sky-50') : (" bg-white border-stone-300 text-gray-900 hover:bg-gray-50 focus-visible:bg-blue-50")} focus-visible:ring-1 `}>
            {option.element !== undefined && (<span
                className={"p-2 h-24 mb-2 flex items-center justify-center bg-white rounded overflow-hidden select-none"}>{option.element}</span>)}


            <div className={"flex items-center"}>
                {(option?.iconName !== undefined) && (
                    <DisplayIcon iconName={option.iconName} className={"mr-2 w-5 h-5"}/>
                )}
                <span
                    className={`text-left ml-1 ${option.className ?? ""}`}>{option.label || "[Lable not found]"}</span>
            </div>


        </button>)

    }

    render() {
        let {sections = [], options = []} = this.props

        let elementsWithNoSection = options.filter((item => (!sections.map(item2 => (item2.name)).includes(item.section))))

        return (
            <div className={"@container h-full w-full"}
                 style={{position: "static", display: "inline-block", width: this.props.width}}>


                {sections.length === 0 ? (<>
                    <div className=" grid grid-cols-1 gap-2  @xs:grid-cols-2 @xl:grid-cols-4 @4xl:grid-cols-5">
                        {options.map((item, index) => this.displayItem(item, index))}

                    </div>

                </>) : (<>
                    {sections.map((section, index) => {
                        let sectionElements = options.filter(item => (item.section === section.name))
                        if (sectionElements.length !== 0) {
                            return (<GridSection title={section.label}>
                                {sectionElements.map((item, index) => this.displayItem(item, index))}
                            </GridSection>)

                        }
                    })}

                    <ul className="relative z-0  pt-4  grid grid-cols-1 @xs:grid-cols-2  gap-2   pb-1">
                        {elementsWithNoSection.map((item, index) => this.displayItem(item, index))}

                    </ul>
                </>)}


            </div>
        )
    }
}

CardsSelect.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]),
    options: PropTypes.array,
    onChange: PropTypes.func,
    isReadOnly: PropTypes.bool

};

CardsSelect.defaultProps = {
    options: []
}


export default CardsSelect;